export * from './addbasefile.component';
